/* plaimanas.js */

function SwatchSliderLoad() {
  document.querySelectorAll('.goodr-product-grid-item-new').forEach(function(card) {
    var viewport = card.querySelector('.slider-viewport');
    var track = card.querySelector('.slider-track');
    var prevBtn = card.querySelector('.arrow.left');
    var nextBtn = card.querySelector('.arrow.right');

    if (!viewport || !track || track.children.length < 2) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }

    function getSlideWidth() {
      var slide = track.children[0];
      if (!slide) return 0;
      var style = getComputedStyle(slide);
      return slide.offsetWidth + parseFloat(style.marginRight);
    }

    function updateArrows() {
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      if (maxScroll <= 1) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
        return;
      }
      prevBtn.style.display = 'grid';
      nextBtn.style.display = 'grid';
      var atStart = viewport.scrollLeft <= 1;
      var atEnd = viewport.scrollLeft >= maxScroll - 1;
      prevBtn.classList.toggle('is-disabled', atStart);
      nextBtn.classList.toggle('is-disabled', atEnd);
    }

    function waitForScrollable() {
      if (viewport.scrollWidth > viewport.clientWidth) {
        updateArrows();
      } else {
        requestAnimationFrame(waitForScrollable);
      }
    }

    waitForScrollable();

    nextBtn.addEventListener('click', function() {
      viewport.scrollBy({ left: getSlideWidth(), behavior: 'smooth' });
    });

    prevBtn.addEventListener('click', function() {
      viewport.scrollBy({ left: -getSlideWidth(), behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', updateArrows);

    var ro = new ResizeObserver(updateArrows);
    ro.observe(card);
    ro.observe(viewport);
    ro.observe(track);

    track.querySelectorAll('img').forEach(function(img) {
      if (!img.complete) {
        img.addEventListener('load', updateArrows);
      }
    });

    window.addEventListener('load', updateArrows);

    viewport.querySelectorAll('a').forEach(function(a) {
      a.setAttribute('draggable', 'false');
      a.addEventListener('dragstart', function(e) { e.preventDefault(); });
    });

    var isDown = false;
    var startX;
    var scrollLeft;
    var dragged = false;

    viewport.addEventListener('mousedown', function(e) {
      isDown = true;
      dragged = false;
      startX = e.pageX;
      scrollLeft = viewport.scrollLeft;
    });

    viewport.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      var walk = e.pageX - startX;
      if (Math.abs(walk) > 5) dragged = true;
      if (dragged) {
        e.preventDefault();
        viewport.scrollLeft = scrollLeft - walk;
      }
    });

    viewport.addEventListener('mouseup', function() { isDown = false; });
    viewport.addEventListener('mouseleave', function() { isDown = false; });

    viewport.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function(e) {
        if (dragged) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.accordion-item-box').forEach(function (box) {
    var heading = box.querySelector('.accordion');
    if (heading && heading.textContent.trim() === '') {
      box.remove();
    }
  });

  document.querySelectorAll('.image-with-text').forEach(function (el) {
    var hasPlaceholder = el.querySelector('.image-with-text__placeholder');
    var content = el.querySelector('.image-with-text__content');
    var contentEmpty = content && content.innerHTML.trim() === '';
    if (hasPlaceholder && contentEmpty) {
      el.remove();
    }
  });

  document.querySelectorAll('.promo-grid--container').forEach(function (section) {
    var cards = section.querySelectorAll('.goodr-card-info-container');
    if (cards.length === 0) return;
    var hasProduct = Array.from(cards).some(function (card) {
      var style = card.getAttribute('style') || '';
      return style.indexOf('background-image') !== -1;
    });
    if (!hasProduct) {
      section.style.display = 'none';
    }
  });

  SwatchSliderLoad();
});
